/**
 * @generated SignedSource<<2cd5a7605c6bea1629bd54c13b3cc3ad>>
 * @relayHash 0a8aa2ee95398136d2a8adbc81542fe2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 978bca313c8bcead1ee5d4e7f6ac22f99d427d771830ebcf4d69081ed9fc605d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isConditionsFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-parent-trigger-conditions.relayprovider';
import isTemplateAnalyticsEnabled_provider from '@atlassian/jira-relay-provider/src/journey-builder-template-analytics-fe.relayprovider';
import isJbRovoIntegrationEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-journey-builder-rovo-integration.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "978bca313c8bcead1ee5d4e7f6ac22f99d427d771830ebcf4d69081ed9fc605d",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": isConditionsFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderrovointegrationrelayprovider": isJbRovoIntegrationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderparenttriggerconditionsrelayprovider": isConditionsFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjourneybuildertemplateanalyticsferelayprovider": isTemplateAnalyticsEnabled_provider
    }
  }
};

export default node;
